<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-tabs v-model="tab" grow>
          <v-tab key="0">Lista</v-tab>
          <v-tab key="1" v-show="$can('do','POKO_RezerwyDodawanie')">Dodawanie</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item key="0" >
            <ListReserves v-if="tab == 0" :therapist-id="therapistID"></ListReserves>
          </v-tab-item>
          <v-tab-item key="1">
            <AddReserve v-if="tab == 1 && $can('do','POKO_RezerwyDodawanie')" @OnAddedReserve="addedReserve"></AddReserve>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ListReserves from "@/components/reserves/ListReserves";
import AddReserve from "@/components/reserves/AddReserve";
export default {
  name: "Reserves",
  components: {AddReserve, ListReserves},
  data() {
    return {
      tab: null,
      therapistID: 0
    }
  },
  methods: {
    addedReserve(reserve) {
      this.therapistID = reserve.therapist.id
      this.tab = 0
    }
  },
  watch: {
    tab: function(val) {
      if(val != 0)
      {
        this.therapistID = 0
      }
    }
  }
}
</script>

<style scoped>

</style>